export default __webpack_public_path__ + "static/media/37A94B6F-3D0D-472A-83BE-E99C2CA3F859_1_105_c.e2db876d.jpg";